module.exports = __webpack_public_path__ + "static/media/Stellapps_logo_Horizontal.5ace2b6c.png";